const $header = document.querySelector('.js-st-Header__inner');

window.addEventListener('scroll', header_scroll);

function header_scroll() {
  const scroll_position = window.scrollY;

  if(scroll_position > 100) {
    $header.classList.add('is-change');
  } else {
    $header.classList.remove('is-change');
  }

  if(scroll_position > 200) {
    $header.classList.add('is-fixed');
  } else {
    $header.classList.remove('is-fixed');
  }

  if(scroll_position > 300) {
    $header.classList.add('is-show');
  } else {
    $header.classList.remove('is-show');
  }
}
